var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 32,
    viewBox: "0 0 20 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9219 15.5868H17.4781C17.9308 15.5868 18.2083 16.0978 17.9689 16.4819L12.5072 25.3413L8.29416 32H0L4.21299 25.3413L9.83782 16.2C9.9523 16.0079 9.82568 15.7648 9.61061 15.7648H3.05437C2.60168 15.7648 2.32417 15.2661 2.56352 14.882L7.97502 6.03491L11.6694 0H20L16.3056 6.03491L10.6929 15.1639C10.5802 15.3436 10.7051 15.585 10.9184 15.585L10.9219 15.5868Z",
    fill: "#09D1D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.b2fd59176805c72d3c1c79ce1cfc0024.svg";
export { ForwardRef as ReactComponent };